module.exports = __webpack_public_path__ + "static/media/pen.5faa3850.svg";